// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a135e1eb","239":"770a06ef","453":"4b1ef2bf","455":"a0824e8f"}[chunkId] + ".chunk.js";
};